import { useCallback, useContext, useEffect, useState } from 'react';
import { ClientShop, ClientShopSchema } from '../clientContracts/clientShops/entities';
import UserContext from '../context/userContext';
import requestHandler from '../utils/requestHandler';

export function useClientShops({ includeNonAuthed = false }: { includeNonAuthed?: boolean }) {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(15);
    const [clientShops, setClientShops] = useState<ClientShop[]>([]);
    const [selectedClientShop, setSelectedClientShop] = useState<ClientShop>();
    const [loading, setLoading] = useState(true);
    const user = useContext(UserContext);

    const getClientShops = useCallback(async () => {
        if (user?.activeClient?.id) {
            const results = await requestHandler(
                'GET',
                `/api/client-shops?page=${page}&limit=${limit}&includeNonAuthed=${
                    includeNonAuthed ? 1 : 0
                }`,
            );
            if (results.success) {
                const { payload } = results;
                const validatedPayload = ClientShopSchema.array().safeParse(payload);
                if (validatedPayload.success) {
                    setClientShops(validatedPayload.data);

                    if (validatedPayload.data.length) {
                        setSelectedClientShop(validatedPayload.data[0]);
                    }
                }
                if (!validatedPayload.success) {
                    setClientShops([]);
                    setSelectedClientShop(undefined);
                }
            }
            if (results.status === 400) {
                getClientShops();
            }
            if (results.status === 204 && !results.error) {
                setClientShops([]);
            }
            setLoading(false);
        }
    }, [page, limit, includeNonAuthed, user?.activeClient?.id]);

    useEffect(() => {
        getClientShops();
    }, [getClientShops]);

    return {
        clientShops,
        selectedClientShop,
        setSelectedClientShop,
        setPage,
        setLimit,
        getClientShops,
        loading,
    };
}
